/* ---------------------------------- Types --------------------------------- */

export interface FailConstructorI {
    /** A message which can be seen by end users, potentially event shown in notifications. */
    userMessage: string;

    /** Unique key for the specific type of error being thrown */
    key: string;

    /** Optional additional information that may be useful in handling or reporting the error */
    data?: unknown;
}

/* ---------------------------------- Fail ---------------------------------- */

export class Fail {
    /** Optional additional information that may be useful in handling or reporting the error */
    readonly data?: unknown;

    /** Unique key for the specific type of error being thrown */
    readonly key: string;

    /** Stack trace for where the error was created */
    readonly location: string | undefined;

    /** A message which can be seen by end users, potentially event shown in notifications. */
    readonly userMessage: string;

    constructor({ data, key, userMessage }: FailConstructorI) {
        this.data = data;
        this.key = key;
        this.location = Error().stack;
        this.userMessage = userMessage;
    }

    /**
     * toObject
     *
     * Converts the fail class to an object
     *
     * @returns An error object
     */
    toObject() {
        return Object.freeze({
            data: this.data,
            key: this.key,
            location: this.location,
            userMessage: this.userMessage,
        });
    }

    /**
     * toString
     *
     * Converts the fail class to a string
     *
     * @returns The error message
     */
    toString() {
        return this.userMessage;
    }

    /**
     * Fail.from
     *
     * Static function to create a new fail class instance from an existing one
     * Useful when converting from one fail class type to another
     *
     * @param f - The existing fail class instance
     * @returns A new instance of a fail class
     */
    static from(f: Fail) {
        return new this({ ...f.toObject() });
    }
}
